module.exports = __webpack_public_path__ + "static/media/nai_hsin_li.af3bb11a.jpg";